//公用模板 暂时用于工具下载下的激活客户端、OEM用户下载登录成功显示数据、和OEM搜索结果显示及激活客户端搜索结果显示
<template>
  <div class="public" style="min-width: 1050px">
    <div class="top_title">
      <span>{{show_title}}</span>
    </div>
    <div class="main">
      <ul class="title">
        <li style="width: 30%">安装镜像</li>
        <li style="width: 10%">大小</li>
        <li style="width: 10%">下载</li>
        <li style="width: 30%">升级镜像</li>
        <li style="width: 10%">大小</li>
        <li style="width: 10%">下载</li>
      </ul>
      <p class="tips" v-if="searchShow">
        搜索结果：
        <span v-if="list.length === 0">--无匹配结果--</span>
        <span class="close" title="关闭" @click="closeSearch()">X</span>
      </p>
      <p class="tips" v-if="$route.params.id === 'oem' && list.length === 0">
        <span v-if="list.length === 0">--无对应数据--</span>
      </p>
      <ul v-for="(item,index) in list">
        <li :title="item.image_description" style="child-align: top; width: 30%">
          <p style="white-space: nowrap">{{item.image_description}}</p>
        </li>
        <li style="width: 10%">{{item.image_size}}</li>
        <li style="width: 10%">
          <a :href="item.image_link" target="_blank">
            <img :src="downloadIcon" alt="下载" />
          </a>
        </li>
        <li :title="item.update_image_description" style="child-align: top; width: 30%">
          <p style="white-space: nowrap">{{item.update_image_description}}</p>
        </li>
        <li style="width: 10%">{{item.update_image_size}}</li>
        <li style="width: 10%">
          <a v-if="item.update_image_link!=''" :href="item.update_image_link" target="_blank">
            <img :src="downloadIcon" alt="下载" />
          </a>
          <p v-if="item.update_image_link==''">无</p>
        </li>
      </ul>
      <ul v-for="(item,index) in list">
        <li :title="item.image_md5_title" style="child-align: top; width: 50%">
          <p style="text-align: center">SHA256: <br>{{item.image_md5}}</p>
        </li>
        <li :title="item.update_image_md5_title" style="child-align: top; width: 50%">
          <p style="text-align: center">SHA256: <br>{{item.update_image_md5}}</p>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import { post, fetch } from "@/util/http";
import { mapGetters, mapActions } from "vuex";
export default {
  name: "public",
  watch: {
    $route(to, from) {
      let self = this;
      self.isShow = -1;
      self.list = [];
      self.searchShow = false;
      if (!sessionStorage.getItem("isLogin") && to.params.id === "pcibSn") {
        this.$router.push({ name: "pcibSnLogin" });
      } else if (sessionStorage.getItem("isLogin") && to.params.id === "pcibSn") {
        self.show_title = "镜像下载";
      }
    }
  },
  beforeCreate: function() {
    let self = this;
    self.list = [];
    if (!sessionStorage.getItem("isLogin") && this.$route.params.id === "pcibSn") {
      this.$router.push({ name: "pcibSnLogin" });
    } else if (sessionStorage.getItem("isLogin") && this.$route.params.id === "pcibSn")
    {
      self.show_title = "镜像下载";

      post("user/imagePcibSnList/", {
          pcib_sn: sessionStorage.getItem('pcib_sn'),
        },
        {
          "Content-Type": "application/json", //设置跨域头部
          // Authorization: "JWT " + sessionStorage.getItem("oemToken")
        }
      ).then(
        res => {
          try{
            self.list.push(
              {
                image_description: res.image_description,
                image_md5: res.image_md5,
                image_name_dis: res.image_name + ' SHA256:' + res.image_md5.slice(0,10) + '...',
                image_md5_title: 'SHA256: ' + res.image_md5,
                image_size: (res.image_size / 1024 / 1024).toFixed(2) + "M",
                image_link: res.image_link,
                update_image_description: res.hasOwnProperty('update_image_description')?res.update_image_description:'无',
                update_image_md5: res.hasOwnProperty('update_image_md5')?res.update_image_md5:'NA',
                update_image_name_dis: res.hasOwnProperty('update_image_name')?res.update_image_name + ' SHA256:' +
                  res.update_image_md5.slice(0,10) + '...':'无',
                update_image_md5_title: res.hasOwnProperty('update_image_md5')?'SHA256: ' + res.update_image_md5:'',
                update_image_size: res.hasOwnProperty('update_image_size')?(res.update_image_size / 1024 / 1024).toFixed(2) + "M":'NA',
                update_image_link: res.hasOwnProperty('update_image_link')?res.update_image_link:'',
              }
            )
          } catch (e) {
            console.info('error:' + e)
          }

        },
        err => {
          sessionStorage.removeItem("isLogin");
          sessionStorage.removeItem("oemToken");
          self.$router.push({ name: "pcibSnLogin" });
        }
      );
    } else {
      this.$router.replace({ name: "error" });
    }
  },
  mounted: function() {
    if (this.$route.params.id === "pcibSn") {
      this.show_title = "镜像下载";
    }
  },
  computed: {
    ...mapGetters("config", {
      getToolsClassifyList: "getToolsClassifyList"
    })
  },
  data() {
    return {
      downloadIcon: "/static/img/file_download.png",
      list: [],
      tele: "", //用于存放验证的手机号
      isShow: -1, //用于控制下载地址链接
      show_title: "", //模板标题
      searchShow: false
    };
  },
  methods: {
    getShowTitleFromMenus() {
      this.show_title = '镜像下载'
    },
    ...mapActions("config", {
      getToolsClassifyListAction: "getToolsClassifyListAction"
    })
  }
};
</script>



// WEBPACK FOOTER //
// src/pages/publics/PcibSnPublic.vue